import {
	fetch,
	post,
} from '@/utils/api'
import _config from 'config'
//查询精选理财
//1:海通严选
//2:爆款基金
//3:精选理财
const queryHtyxList = (param = {}) => {
	// var paraMap = params || {}

	let paraMap = {}
	paraMap['funcNo'] = '1013741'
	paraMap['type'] = param['type'] // 查询类型 1.海通严选  2.爆款基金,默认1
	paraMap['rows'] = param['rows'] // 查询条数
	return fetch(paraMap)
}

//获取自选基金
const queryCustomFund = (param = {}) => {
	let paraMap = {}
	paraMap['funcNo'] = '1013743'
	paraMap['type'] = param.type
	paraMap['sy'] = param.sy
	paraMap['fxdj'] = param.fxdj
	paraMap['xj'] = param.xj
	paraMap['isCanBuy'] = param.isCanBuy
	paraMap['rgqd'] = param.rgqd
	paraMap['com_code'] = param.com_code
	paraMap['rows'] = param.rows
	paraMap['pageId'] = param.pageId
	paraMap['sort'] = param.sort
	paraMap['keyword'] = param.keyword
	paraMap['ordertype'] = param.ordertype
	paraMap['com_code'] = param.com_code
	paraMap['currentPage'] = param.currentPage
	paraMap['filterfx'] = param.filterfx
	paraMap['isCanBuy'] = param.isCanBuy
	return fetch(paraMap)
}

//获取基金详情
const queryFundInfo = (param = {}) => {
	let paraMap = {}
	paraMap['funcNo'] = '1013702'
	paraMap['fund_code'] = param.fund_code
	return fetch(paraMap)
}

//获取基金历史净值信息
const queryFundYield = (param = {}) => {
	let paraMap = {}
	paraMap['funcNo'] = '1013704'
	paraMap['fund_code'] = param.fund_code
	paraMap['type'] = param.type
	paraMap['is_query_profit'] = param.is_query_profit //查询收益数据
	paraMap['startime'] = param.startime
	paraMap['endtime'] = param.endtime
	return fetch(paraMap)
}

/**
 * 基金业绩排行 功能 （自选查询）
 */
//查询自选基金
const queryFollowFund = (param = {}) => {
	let paraMap = {}
	paraMap['funcNo'] = '1013711'
	paraMap['fundcode'] = param.fundcode
	paraMap['isdt'] = param.isdt
	paraMap['filterfx'] = param.filterfx
	return fetch(paraMap)
}

//查询榜单列表
const queryRankingList = (param = {}) => {
	let paraMap = {}
	paraMap['funcNo'] = '1013754'
	paraMap['type'] = param['type'] // 查询方式  1.排序值方式查询   2.随机方式查询
	paraMap['rows'] = param['rows'] // 查询条数
	return fetch(paraMap)
}

//榜单详情查询
const queryRankingDetail = (param = {}) => {
	let paraMap = {}
	paraMap['funcNo'] = '1013755'
	paraMap['id'] = param['id']
	paraMap['type'] = param['type']
	return fetch(paraMap)
}

//异步查询手机号是否激活
const queryPhone = (param = {}) => {
	let paraMap = {}
	paraMap['funcNo'] = '1013400'
	paraMap['client_id'] = param['client_id']
	return post(paraMap)
}

//获取加密模块
const queryRSAkey = (params = {}) => {
	let paraMap = {}
	paraMap['funcNo'] = '1000000'
	return post(paraMap)
}

//用户登录
const userLogin = (param = {}) => {
	let paraMap = {}
	paraMap['funcNo'] = '1010000'
	paraMap['ter_type'] = param.ter_type
	paraMap['client_ver'] = '1000'
	paraMap['client_os_ver'] = param.client_os_ver
	//		paraMap["client_ip"]= "0";//前端不传值，接入层给值
	//		paraMap["client_pub_ip"]= "0";//前端不传值，接入层给值
	//		paraMap["ter_name"]= "xueqiu";//前端不传值，接入层给值
	//		paraMap["ter_channel_no"]= "ht1cac821b24df63ee";//前端不传值，接入层给值
	paraMap['client_hdd'] = param.client_hdd
	paraMap['client_mac'] = param.client_mac
	paraMap['remark'] = param.remark
	paraMap['ter_channel_user_id'] = '' //不必需
	paraMap['net_cate'] = global.net_cate //不必需
	if (param.account_type) {
	 paraMap['account_type'] = param.account_type
	 paraMap['remark'] = param.remark //modify by lili 20170419 -SDK中mac中存入设备唯一id
	} else {
	 paraMap['account_type'] = global.account_type
	}
	paraMap['client_mobile'] = param.client_mobile
	paraMap['login_account'] = param.login_account
	paraMap['trade_pwd'] = param.trade_pwd
	paraMap['auth_type'] = param.auth_type
	paraMap['auth_pwd'] = param.auth_pwd
	paraMap['verify_code'] = param.verify_code
	paraMap['mobileKey'] = param.mobileKey
	paraMap['mobile_code'] = param.mobile_code
	paraMap['sourceapp'] = param.sourceapp //用于OauthTBAS方式的统一登录使用。 sourceapp值为 isapp，调用统一登录接口
	//paraMap["login_local_code"] = param.login_local_code;
	paraMap['3rd_login_token'] = param['3rd_login_token']
	paraMap['sourceid'] = param['sourceid']
	paraMap['useRSACert'] = param['useRSACert']
	paraMap['ter_type_desc'] = param['ter_type_desc']
 
 
 
	return post(paraMap)
 }

//  const userLogin = (param = {}) => {
// 	let paraMap = {}
// 	paraMap['funcNo'] = '1010000'
// 	paraMap['ter_type'] = '10'
// 	paraMap['client_ver'] = '4000'
// 	paraMap['client_os_ver'] = 'iPhone%3B%20CPU%20iPhone%20OS%2013_2_3%20like%20Mac%20OS%20X'
// 	//  paraMap["client_ip"]= "0";//前端不传值，接入层给值
// 	//  paraMap["client_pub_ip"]= "0";//前端不传值，接入层给值
// 	//  paraMap["ter_name"]= "xueqiu";//前端不传值，接入层给值
// 	//  paraMap["ter_channel_no"]= "ht1cac821b24df63ee";//前端不传值，接入层给值
// 	paraMap['client_hdd'] = param.client_hdd
// 	paraMap['client_mac'] = param.client_mac
// 	paraMap['remark'] = param.remark
// 	paraMap['ter_channel_user_id'] = '' //不必需
// 	paraMap['net_cate'] = 1 //不必需
// 	if (param.account_type) {
// 	 paraMap['account_type'] = param.account_type
// 	 paraMap['remark'] = param.remark //modify by lili 20170419 -SDK中mac中存入设备唯一id
// 	} else {
// 	 paraMap['account_type'] = global.account_type
// 	}
// 	paraMap['account_type'] = '4'
// 	paraMap.mobile_code = 989898
// 	paraMap['client_mobile'] = '15995783727'
// 	paraMap['login_account'] = param.login_account
// 	paraMap['trade_pwd'] = param.trade_pwd
// 	paraMap['auth_type'] = param.auth_type
// 	paraMap['auth_pwd'] = param.auth_pwd
// 	paraMap.sourceapp = ''
// 	paraMap['verify_code'] = '178178'
// 	paraMap['verify_code'] = param.verify_code
// 	paraMap['mobileKey'] = param.mobileKey
// 	// paraMap['mobile_code'] = param.mobile_code
// 	paraMap['sourceapp'] = param.sourceapp //用于OauthTBAS方式的统一登录使用。 sourceapp值为 isapp，调用统一登录接口
// 	//paraMap["login_local_code"] = param.login_local_code;
// 	paraMap['3rd_login_token'] = param['3rd_login_token']
// 	paraMap['sourceid'] = param['sourceid']
// 	paraMap['useRSACert'] = param['useRSACert']
// 	paraMap['ter_type_desc'] = param['ter_type_desc']
// 	paraMap.mobileKey = Math.random();
	
	
	
// 	return post(paraMap)
// 	}


//获取产品详细信息
const queryProductInfo = (param = {}) => {
	let paraMap = {}
	paraMap['funcNo'] = '1013504'
	paraMap['cpid'] = param.cpid
	paraMap['jsessionid'] = param.jsessionid
	paraMap['client_id'] = param.client_id
	paraMap['filterfx'] = '5'

	return post(paraMap)
}

//获取理财列表
const queryLcSearchList = (param = {}) => {
	let paraMap = {}
	paraMap['funcNo'] = '1013744'
	paraMap['isNavType'] = param.isNavType || ''
	paraMap['type'] = param.type || ''
	paraMap['qx'] = param.qx || ''
	paraMap['fxdj'] = param.fxdj || ''
	paraMap['cpglr'] = param.com_name || ''
	paraMap['rgqd'] = param.rgqd || ''
	paraMap['cpjd'] = param.cpjd || ''
	paraMap['tzcl'] = param.tzcl || ''
	paraMap['cptx'] = param.cptx || ''
	paraMap['syl'] = param.syl || ''
	paraMap['sort'] = param.sort || ''
	paraMap['keyword'] = param.keyword || ''
	paraMap['sort_type'] = param.sort_type || ''
	paraMap['pageCode'] = param.pageCode || ''
	paraMap['currentPage'] = param.currentPage || ''
	paraMap['rows'] = param.rows || ''
	paraMap['filterfx'] = param.filterfx || ''
	return fetch(paraMap)
}

/**
 * 查询合格投资者认定
 */
const getInvestInfo = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1013609'
	paraMap['clientId'] = param.client_id
	paraMap['client_id'] = param.client_id

	return post(paraMap)
}

/**
 * 新增合格投资者认定
 */
const addInvestInfo = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1013610'
	paraMap['clientId'] = param.client_id
	paraMap['signPage'] = param.signPage

	return post(paraMap)
}

/**
 * 基金详情查询
 */
const queryPrivateFundInfo = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1011512'
	paraMap['data'] = param.data
	paraMap['head'] = param.head
	paraMap['client_id'] = param.client_id
	paraMap['jsessionid'] = param.jsessionid || ''
	paraMap['filterfx'] = param.filterfx || ''

	return post(paraMap)
}

/**
 * 电子合同状态查询
 */
const queryContractStatus = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1011520'
	paraMap['client_id'] = param.client_id
	paraMap['data'] = param.data
	paraMap['head'] = param.head

	return post(paraMap)
}

//查询客户电子签名约定书权限
const queryMRight = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1011519'
	paraMap['data'] = param.data
	paraMap['head'] = param.head

	return post(paraMap)
}

//基金公司查询（是否在该基金公司开户）
const queryFundAccountOpenInfo = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1011501'
	paraMap['data'] = param.data
	paraMap['head'] = param.head

	return post(paraMap)
}

/**
 * 开放式基金适当性匹配结果查询[3283]
 * @param head:多行入参字段
 *        head入参字段:
 * @param data:多行入参值
 */
const queryAppropriate_fund = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1012531'
	paraMap['head'] = param.head
	paraMap['data'] = param.data

	return post(paraMap)
}

/**
 * 功能：OTC资产查询
 * 参数: callback:回调函数
 * @param   head 多行入参字段
 * @param   data 多行入参值
 */
const queryOtcFund = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1012509'
	paraMap['head'] = param.head
	paraMap['data'] = param.data

	return post(paraMap)
}

/**查询附件列表
 *
 */
const searchEnclosureList = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1013505'
	paraMap['cpid'] = param.cpid
	paraMap['hasDxjr'] = param.hasDxjr

	return fetch(paraMap)
}

/**
 * 基金申购
 */
const fundApply = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1011503'
	paraMap['data'] = param.data
	paraMap['head'] = param.head
	paraMap['econtract_code'] = param.econtract_code
	paraMap['business_info'] = param.business_info
	paraMap['orderlist'] = param.orderlist
	paraMap['product_type'] = param.product_type
	return post(paraMap)
}

/**
 * 基金认购
 */
const fundSubscribe = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1011502'
	paraMap['data'] = param.data
	paraMap['head'] = param.head
	paraMap['econtract_code'] = param.econtract_code
	paraMap['business_info'] = param.business_info
	paraMap['orderlist'] = param.orderlist
	paraMap['product_type'] = param.product_type

	return post(paraMap)
}

/**
 * 功能：查询股东账号
 */
const querySecAccount = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1010012'
	paraMap['head'] = param.head
	paraMap['data'] = param.data

	return post(paraMap)
}

/**
 * 功能：OTC产品信息查询
 * product_no ：产品代码
 */
const queryOtcFundInfo = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1012500'
	paraMap['head'] = param.head
	paraMap['data'] = param.data

	return post(paraMap)
}

/**
 * 适当性匹配结果查询[3281]
 * @param head:多行入参字段
 *        head入参字段:
 * @param data:多行入参值
 */
const queryAppropriate = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1012530'
	paraMap['head'] = param.head
	paraMap['data'] = param.data

	return post(paraMap)
}

/**
 * 功能：OTC产品委托
 * market_code    交易市场标志
 * entrust_type    委托类型
 * sec_account    股东账号
 * product_no    产品代码
 * entrust_price    委托价格
 * entrust_amt    委托数量
 */
const otcEntrust = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1012501'
	paraMap['head'] = param.head
	paraMap['data'] = param.data
	paraMap['econtract_code'] = param.econtract_code
	paraMap['business_info'] = param.business_info
	paraMap['orderlist'] = param.orderlist

	return post(paraMap)
}

/**
 * 基金详情-基金信息
 */
const getFundDetailInfo = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1013705'
	paraMap['fund_code'] = param.fund_code

	return fetch(paraMap)
}

/**
 * 商城产品搜索
 */
const searchProListByType = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1013745'
	paraMap['keyword'] = param.keyword
	paraMap['rows'] = param.rows
	paraMap['search_type'] = param.search_type
	paraMap['each_rows'] = param.each_rows
	paraMap['product_type'] = param.product_type
	paraMap['currentPage'] = param.currentPage
	paraMap['filterfx'] = param.filterfx

	return fetch(paraMap)
}

/**
 * 获取适当性文档信息
 */
const getSdxPdfList = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1013750'
	paraMap['productFlag'] = param.productFlag

	return fetch(paraMap)
}

/**
 * 功能：查询OTC行情成交量
 * market_code ：市场
 * product_no ：产品代码
 */
const queryOtcHq = (param = {}) => {
	var paraMap = {}
	paraMap['funcNo'] = '1012519'
	paraMap['head'] = param.head
	paraMap['data'] = param.data

	return post(paraMap)
}

/**
 * 功能：电子合同签署
 * market_code ：市场
 * product_no ：产品代码
 */
const signContract = (param = {}) => {
	var paraMap = {}
	paraMap["funcNo"] = "1011521"
	paraMap["data"] = param.data
	paraMap["head"] = param.head

	return post(paraMap)
}


/**
 * 资产配置信息查询
 *   1.基金基本信息
 *   2.资产配置信息
 *   3.持仓行业信息
 *   4.持仓股票信息
 *   5.十大交易记录信息
 */
const searchAccForm = (param = {}) => {
	var paraMap = {};
	paraMap["funcNo"] = "1013723";
	paraMap["fund_code"] = param.fund_code;

	return fetch(paraMap)
};


/**
 * 资产配置信息查询
 *   1.持仓行业信息
 *   2.持仓股票信息
 *   3.十大交易记录信息
 */
const searchAccForm_IndstTrade = (param = {}) => {
	var paraMap = {};
	paraMap["funcNo"] = "1013724";
	paraMap["fund_code"] = param.fund_code;

	return fetch(paraMap)
};


/**
 * 基金详情-基金经理
 */

const getFundDetailManager = (param = {}) => {
	var paraMap = {};
	paraMap["funcNo"] = "1013707";
	paraMap["fund_code"] = param.fund_code;

	return fetch(paraMap)
};

/**
 * 基金详情-基金公司
 */
const getFundDetailCompany = (param = {}) => {
	var paraMap = {};
	paraMap["funcNo"] = "1013708";
	paraMap["fund_code"] = param.fund_code;
	paraMap["com_code"] = param.com_code;

	return fetch(paraMap)
};

/**
 * 基金详情-基金分红
 */
const getFundDetailDid = (param = {}) => {
	var paraMap = {};
	paraMap["funcNo"] = "1013709";
	paraMap["fund_code"] = param.fund_code;

	return fetch(paraMap)
};

/**
 * 查询基金公告
 */
// const getFundNotice = (param = {}) => {
// 	var paraMap = {};
// 	paraMap["funcNo"] = "1014596";
// 	paraMap["fund_code"] = param.fund_code;
// 	paraMap["notice_type"] = param.notice_type;
// 	paraMap["time_quantum"] = param.time_quantum;
// 	paraMap["cur_page"] = param.cur_page;
// 	paraMap["num_per_page"] = param.num_per_page || 10;

// 	return post(paraMap)
// };

const getFundNotice = (param = {}) => {
	var paraMap = {};
	// paraMap["funcNo"] = "1014596";
	// paraMap["fund_code"] = param.fund_code;
	// paraMap["notice_type"] = param.notice_type;
	// paraMap["time_quantum"] = param.time_quantum;
	// paraMap["cur_page"] = param.cur_page;
	// paraMap["num_per_page"] = param.num_per_page || 10;
	// param.fund_code = '000991'
	paraMap["TradingCode"] = "OF" + param.fund_code; // OF代表场内 + 基金代码
	paraMap["PageNum"] = param.cur_page; // 当前页
	paraMap["PageSize"] = param.num_per_page || 10; // 条数
	paraMap["Type"] = "Ann"; // 接口类型(默认写死)
	paraMap["SourceType"] = param.notice_type || "All"; 
	paraMap["Date"] = param.time_quantum || '0';
	return fetch(paraMap,{apiUrl:_config.infoServerPath+'/api/FundNewsAnnList',withCredentials:false})
};

/**
 * 查询银行费率
 */
const searchBankRate = (param = {}) => {
	var paraMap = {};
	paraMap["funcNo"] = "1013726";

	return fetch(paraMap)
};

/**
 * 详情首页
 */
const getPrivateBasicInfo = (param = {}) => {
	var paraMap = {};
	paraMap["funcNo"] = "1013606";
	paraMap["cpid"] = param.cpid;
	paraMap["client_id"] = param.client_id;
	paraMap["jsessionid"] = param.jsessionid;
	paraMap["filterfx"] = param.filterfx;

	return post(paraMap)
};

/**
 * 定投参数查询
 * @param head:多行入参字段
 *        head入参字段:
 * @param data:多行入参值
 */
const queryAutoInveEnum = (param = {}) => {
	var paraMap = {};
	paraMap["funcNo"] = "1011514";
	paraMap["head"] = param.head;
	paraMap["data"] = param.data;

	return post(paraMap)
};

/**
 * 基金定投委托
 * @param head:多行入参字段
 *        head入参字段:
 *			ta_code	基金公司代码	Y
 *			fund_code	基金代码	Y
 *			auto_inve_cycle	定投周期	Y
 *			auto_inve_date	定投日期	Y
 *			auto_inve_amt	定投金额	Y
 *			expire_type	期满类型	Y
 *			end_date	终止日期	Y
 *			auto_inve_total	定投总额	Y
 *			auto_inve_priori	定投优先级	Y
 *			postpone_flag	是否顺延	N
 * @param data:多行入参值
 */

const fundAutoInve = (param = {}) => {
	var paraMap = {};
	paraMap["funcNo"] = "1011516";
	paraMap["head"] = param.head;
	paraMap["data"] = param.data;
	paraMap['econtract_code'] = param.econtract_code
	paraMap['business_info'] = param.business_info
	paraMap['orderlist'] = param.orderlist

	return post(paraMap)
};

/**查询附件列表 - 含法律文件与公告
 *
 */
const searchEnclosureANDGGList = (param = {}) => {
	var paraMap = {};
	paraMap["funcNo"] = "1013515";
	paraMap["cpid"] = param.cpid;

	return post(paraMap)
};

/**查询资讯列表对接
 *
 */

const getAppggList = (param = {}) => {
	var paraMap = {};
	paraMap["funcNo"] = "1013015";
	paraMap["TypeCode"] = param.TypeCode;
	paraMap["curpage"] = param.curpage;
	paraMap["numPerPage"] = param.numPerPage;

	return fetch(paraMap)
};

/**获取养老基金
 *
 */
 const fetchOldFund = (param = {}) => {
	var paraMap = {};
	paraMap["funcNo"] = "1013763";
	paraMap["fxdj"] = param.fxdj;
	paraMap["rgqd"] = param.rgqd;
	paraMap["htpj"] = param.htpj;

	return post(paraMap)
};

/**获取新发基金
 *
 */
 const fetchNewFund = (param = {}) => {
	var paraMap = {};
	paraMap["funcNo"] = "1013716";
	paraMap["type"] = param.type;
	paraMap["rows"] = param.rows;
	paraMap["keyword"] = param.keyword;
	paraMap["pageId"] = param.pageId;
	paraMap["currentPage"] = param.currentPage;
	paraMap["filterfx"] = param.filterfx;
	paraMap["fxdj"] = param.fxdj;
	paraMap["rgqd"] = param.rgqd;

	return post(paraMap)
};
/**获取金牛基金
 *
 */
 const queryTaurusFund = (param = {}) => {
	var paraMap = {};
	paraMap["funcNo"] = "1017106";
	paraMap["special_type"] = param.special_type || '2';
	paraMap["numperpage"] = param.numperpage || '5';
	paraMap["page"] = param.page || '1';
	paraMap["product_show_home"] = param.product_show_home || '0';
	paraMap["is_query_page"] = param.is_query_page;

	return fetch(paraMap)
};

/**
 * 获取中台配置字典信息
 */
const fetchSdxMatch= (param = {}) => {
	var paraMap = {};
	paraMap["funcNo"] = "1013752";
	paraMap['enum_no'] = param.enum_no
	paraMap['item_name'] = param.item_name
	paraMap['math'] = Math.random()
 
	return post(paraMap)
 };

 /**
  * @description: 新增协议查询
  * @param {*} param
  * @return {*}
  */ 
 const getSdxPdfListMore = (param = {}) => {
	var paraMap = param || {};
	paraMap["funcNo"] = "1014723";
	paraMap['enum_no'] = param.enum_no
	paraMap['item_name'] = param.item_name
	paraMap['math'] = Math.random()
 
	return post(paraMap)
 };

//  获取适当性协议
 const getSdxMatch = (param = {}) => {
	var paraMap = param || {};
	paraMap["funcNo"] = "1014708";
	return post(paraMap)
 };

  /**
  * @description: 协议渲染
  * @param {*} param
  * @return {*}
  */ 
	const agreementEffectShow = (param = {}) => {
		var paraMap = param || {};
		paraMap["funcNo"] = "1015020";
		paraMap['math'] = Math.random()
	 
		return post(paraMap)
	 };

	 /**
  * @description: 协议渲染
  * @param {*} param
  * @return {*}
  */ 
	const getFundCompany = (param = {}) => {
		var paraMap = param || {};
		paraMap["funcNo"] = "1014597";
		paraMap['math'] = Math.random()
	 
		return post(paraMap)
	 };

	 const getESBResults = (param = {}) => {
		var paraMap = param || {};
		paraMap["funcNo"] = "1012550";
		paraMap['math'] = Math.random()
	 
		return post(paraMap)
	 };

	 /**
		 * 白名单
		 */
		const queryWhitelist = (param = {}) => {
			var paraMap = {}
			paraMap['funcNo'] = '1017188'
			paraMap['fund_account'] = param.fund_account
			paraMap['client_id'] = param.client_id
			paraMap['cpdm'] = param.cpdm
			return post(paraMap)
		}

export {
	queryHtyxList, //查询精选理财
	queryCustomFund, //获取自选基金
	queryFundInfo, //获取基金详情
	queryFundYield, //获取基金历史净值信息
	queryFollowFund, //查询自选基金
	queryRankingList, //查询榜单列表
	queryRankingDetail, //榜单详情查询
	queryPhone, //异步查询手机号是否激活
	queryRSAkey, //获取加密模块
	userLogin, //用户登录
	queryProductInfo, //获取产品详细信息
	queryLcSearchList, //获取理财列表
	getInvestInfo, //查询合格投资者认定
	addInvestInfo, //新增合格投资者认定
	queryPrivateFundInfo, //基金详情查询
	queryContractStatus, //电子合同状态查询
	queryMRight, //查询客户电子签名约定书权限
	queryFundAccountOpenInfo, //基金公司查询（是否在该基金公司开户）
	queryAppropriate_fund, //开放式基金适当性匹配结果查询[3283]
	queryOtcFund, //OTC资产查询
	searchEnclosureList, //查询附件列表
	fundApply, //基金申购
	fundSubscribe, //基金认购
	querySecAccount, //查询股东账号
	queryOtcFundInfo, //OTC产品信息查询
	queryAppropriate, //适当性匹配结果查询[3281]
	otcEntrust, //OTC产品委托
	getFundDetailInfo, //基金详情-基金信息
	searchProListByType, //商城产品搜索
	getSdxPdfList, //获取适当性文档信息
	queryOtcHq, //查询OTC行情成交量
	signContract, //电子合同签署
	searchAccForm, //资产配置信息查询
	searchAccForm_IndstTrade, //资产配置信息查询
	getFundDetailManager, //基金详情-基金经理
	getFundDetailCompany, //基金详情-基金公司
	getFundDetailDid, //基金详情-基金分红
	searchBankRate, //查询银行费率
	getPrivateBasicInfo, //私募基金
	queryAutoInveEnum, //定投参数查询
	fundAutoInve, //基金定投委托
	searchEnclosureANDGGList, //查询附件列表 - 含法律文件与公告
	getAppggList, //查询资讯列表对接
	getFundNotice, //查询 基金公告
	fetchOldFund,
	fetchNewFund,
	queryTaurusFund,// 金牛基金
	fetchSdxMatch,//适当性匹配字典
	getSdxPdfListMore,//协议查询
	getSdxMatch, //获取适当性协议
	agreementEffectShow,//协议渲染
	getFundCompany, //基金公司详情
	getESBResults,
	queryWhitelist, //白名单
}



// WEBPACK FOOTER //
// ./src/service/service.js